<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <!--高级搜索Begin-->
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <el-search
          ref="elSearch"
          width="460px"
          :formProp="formData"
          @search="search"
          :isShowSearch="true"
          class="ccui-highsearch no-print"
        >
          <template slot="search">
            <el-date-picker
              v-model="formData.publishTime"
              searchLabel="发布时间"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
            <el-input
              v-model.trim="formData.title"
              clearable
              searchLabel="标题"
              placeholder="请输入标题模糊查询"
            ></el-input>
            <!-- <el-select
              v-if="source != 6"
              class="ccui-form-longInput"
              v-model="formData.interfaceType"
              searchLabel="分类"
              placeholder="请选择分类查询"
              clearable
            >
              <el-option
                v-for="item in faceTypeList"
                :key="item.dicKey"
                :label="item.dicValue"
                :value="item.dicKey"
              >
              </el-option>
            </el-select> -->
          </template>
          <el-date-picker
            v-model="formData.publishTime"
            searchLabel="发布时间"
            clearable
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            slot="searchItem1"
          >
          </el-date-picker>
          <el-input
            v-model.trim="formData.title"
            clearable
            searchLabel="标题"
            placeholder="请输入标题模糊查询"
            slot="searchItem2"
          ></el-input>
          <!-- <el-select
            v-if="source != 6"
            class="ccui-form-longInput"
            v-model="formData.interfaceType"
            searchLabel="分类"
            placeholder="请选择分类查询"
            slot="searchItem5"
            clearable
          >
            <el-option
              v-for="item in faceTypeList"
              :key="item.dicKey"
              :label="item.dicValue"
              :value="item.dicKey"
            >
            </el-option>
          </el-select> -->
        </el-search>
      </div>
      <!--高级搜索End-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <!--列表中的插槽Begin-->
          <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row[title] }}
            </el-button>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import {
  commonTableWidth,
  marketCynamicAndPriceInfoURL
} from "@/setting/setting";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import request from "@/config/utils/request";
import moment from "moment";
import { setSessionItem, getSessionItem } from "@/basa/utils";
export default {
  name: "marketDynamicAndPriceInfoList",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  activated() {
    let searchFormObj = getSessionItem("pageNo", this.tableName);
    console.log(searchFormObj, "localSearchData");
    if (searchFormObj && searchFormObj.searchForm) {
      this.formDataSearch = { ...searchFormObj.searchForm };
      this.formData = { ...searchFormObj.searchForm };
      this.pageNo = searchFormObj.pageNo;
      this.pageSize = getSessionItem("pageSize", this.tableName) || 10;
      console.log(this.formDataSearch, this.formData, "listBaseTable");
    } else {
      this.formData = {};
      this.formDataSearch = {};
      this.pageNo = 1;
      this.pageSize = 10;
    }
    this.getNoticeList();
  },
  deactivated() {
    this.initData();
  },
  props: {
    currBreadCrumb: {
      type: Array,
      default: () => {
        return [];
      }
    },
    rowsField: {
      type: String,
      default: "rows"
    },
    source: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "title"
    },
    interfaceTypeValue: {
      type: String,
      default: ""
    },
    activeIndex: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      formData: {},
      formDataSearch: {},
      localSearchData: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      faceTypeList: [
        {
          dicValue: "分析报告",
          dicKey: 4
        },
        {
          dicValue: "市场行情",
          dicKey: 2
        },
        {
          dicValue: "行业要闻",
          dicKey: 3
        }
      ],
      unfixedTableThead: Object.freeze([
        {
          label: "序号",
          prop: "id",
          type: "index",
          width: commonTableWidth.serialNoWidth,
          checked: true
        },
        {
          label: "标题",
          prop: "title",
          checked: true,
          // width: 500,
          slot: "title"
        },
        {
          label: "发布时间",
          prop: "pubdate",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      interfaceType: "",
      detail: 0
    };
  },
  methods: {
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowPageLoading: true
      };

      if (this.formData.publishTime && this.formData.publishTime.length !== 0) {
        param.publishStartTime = this.formData.publishTime[0];
        param.publishEndTime = this.formData.publishTime[1];
      }
      // if (this.formData.title1) {
      // param.title = this.formData.title;
      // }
      // Object.assign(param, this.formDataSearch);
      this.$delete(param, "publishTime");
      // this.$delete(param, "title1");
      let url = "";
      if (
        this.source === "1" ||
        this.source === "4" ||
        this.source === "5" ||
        this.source === "6"
      ) {
        if (this.interfaceTypeValue) {
          switch (this.interfaceTypeValue) {
            case "4":
              this.$set(this.formData, "interfaceType", "分析报告");
              break;
            case "2":
              this.$set(this.formData, "interfaceType", "市场行情");
              break;
            case "3":
              this.$set(this.formData, "interfaceType", "行业要闻");
              break;
          }
          param.interfaceType = this.interfaceTypeValue;
        }
        url = marketCynamicAndPriceInfoURL.marketDynamicUrl;
      }
      param.title = this.formData.title;
      for (let key in param) {
        if (param.hasOwnProperty(key)) {
          let v = param[key];
          if (v) {
            if (
              this.source === "1" ||
              this.source === "4" ||
              this.source === "5" ||
              this.source === "6"
            ) {
              url += key + "=" + param[key] + "&";
            } else {
              url += "&" + key + "=" + param[key];
            }
          }
        }
      }

      console.log(url, "request");
      console.log(url, url.split("title="), "request");
      if (url.includes("title=")) {
        if (url.split("title=")[1].split("&")[0]) {
          // 使用encodeURIComponent转码URL中的中文
          const encodedQuery = encodeURIComponent(
            url.split("title=")[1].split("&")[0]
          );
          console.log(encodedQuery, "===777888999===");
          url = url.split("title=")[0] + "title=" + encodedQuery;
        }
      }

      console.log(url, "request11");
      // if (
      //   this.source === "1" ||
      //   this.source === "4" ||
      //   this.source === "5" ||
      //   this.source === "6"
      // ) {
      //   url = url.substring(0, url.length - 1);
      // }
      console.log(url, "request22");
      if (this.source === "1") {
        url = url + "&interfaceType=1";
      }
      console.log(url, "request33");
      request({
        url: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) + url,
        method: "get",
        data: {}
      }).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows.map(item => {
            item.pubdate = item.pubdate
              ? moment(item.pubdate).format("YYYY-MM-DD HH:mm")
              : "";
            return item;
          });
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    addCharacterAfterFirstEqual(str, charToAdd) {
      return str.replace(/^(.*?)=.*$/, `$1=${charToAdd}$&`);
    },
    search(searchData) {
      console.log(searchData.interfaceType, "searchData");
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.localSearchData = JSON.parse(JSON.stringify(searchData));
      setSessionItem("pageNo", this.tableName, {
        pageNo: this.pageNo,
        searchForm: this.localSearchData
      });
      this.getNoticeList(this.formDataSearch);
    },
    //查看
    check(row) {
      // 市场动态和价格信息
      localStorage.setItem(
        "detailInfo",
        JSON.stringify({
          title: row.title,
          pubdate: row.pubdate,
          textInfo: row.textInfo,
          activeIndex: this.activeIndex
        })
      );
      this.$router.push({
        path: "/announcementDetail",
        query: {
          source: this.source,
          interfaceType: this.interfaceTypeValue
        }
      });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .el-form-item__content {
  width: 149px;
}
</style>
